import type { FirebaseApp } from 'firebase/app'
import type { Firestore } from 'firebase/firestore'
import * as React from 'react'
import { useIntl } from 'react-intl'

/**
 * Read-only environment that is made available all components in the app.
 * This object is conceptually equivalent to a global variable. But we don't
 * use global variables and instead pass it down the tree using the React
 * context.
 */
export interface Env {
  firebaseApp: FirebaseApp
  db: Firestore
}

export const Env = React.createContext<Env>({
  firebaseApp: null as any,
  db: null as any,
})

export const useEnv = () => {
  return { ...React.useContext(Env), intl: useIntl() }
}
